import "./office-listing-page.scss";
import mapPinInfoWindowTemplate from "../../components/MapPinInfoWindow/MapPinInfoWindow.hbs";

(function () {
    if (document.querySelectorAll(".js-office-listing-page").length > 0) {
        let map = null;

        const officeListingPage = {
            init: function () {
                officeListingPage.renderMap();
                officeListingPage.toggleOpeningHours();
                officeListingPage.searchOffices();
                officeListingPage.toggleAllOfficesList();
            },
            parseCoordinates: (cord) => {
                let coordinate = cord;

                if (coordinate.includes(",")) {
                    coordinate = coordinate.replace(",", ".");
                }

                return coordinate;
            },
            renderMap: () => {
                const mapContainer = document.getElementById("map");
                const mapLoader = document.getElementById("map__loader");
                const searchButton = document.getElementById("search-offices");
                const searchField = document.getElementById("search-offices-input");

                if (mapContainer) {
                    async function initMap() {
                        const { Map } = await google.maps.importLibrary("maps");

                        map = new Map(document.getElementById("map"), {
                            mapId: '99be96ce516de3af'
                        });

                        google.maps.event.addListenerOnce(map, 'idle', function () {
                            mapLoader.classList.remove("map__loader--loading");
                            searchButton.removeAttribute("disabled");
                            searchField.removeAttribute("disabled");
                        });
                    }

                    initMap();
                }
            },
            setMapPins: (offices) => {
                const officeHits = offices;

                async function renderPins(officeHits) {
                    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
                    const bounds = new google.maps.LatLngBounds();

                    for (let i = 0; i < officeHits.length; i++) {
                        const marker = new AdvancedMarkerElement({
                            map,
                            position: { lat: officeHits[i].latitude, lng: officeHits[i].longitude },
                            title: officeHits[i].officeTitle
                        });

                        bounds.extend({ lat: officeHits[i].latitude, lng: officeHits[i].longitude });
                        const string = mapPinInfoWindowTemplate(officeHits[i]);


                        //Set marker information
                        const infoWindow = new google.maps.InfoWindow();

                        google.maps.event.addListener(marker, 'click', function () {
                            infoWindow.close();
                            infoWindow.setContent(string);
                            infoWindow.open(marker.map, marker);
                        });
                    }

                    //Fit map to marker bounds
                    map.fitBounds(bounds);

                    //Listen to bound change and set the max zoom level
                    google.maps.event.addListenerOnce(map, "bounds_changed", function () {
                        this.setZoom(Math.min(this.getZoom(), 15));
                    });
                }

                renderPins(officeHits);
            },
            toggleOpeningHours: () => {
                const mapResults = document.querySelector(".map__results");

                if (mapResults) {
                    const toggleButtons = mapResults.querySelectorAll(".office__open");

                    toggleButtons.forEach((toggleButton) => {
                        toggleButton.addEventListener("click", (e) => {
                            e.target.classList.toggle("active");
                        })
                    })
                }
            },
            updateSearchHits: (hits) => {
                const hitLabel = document.getElementById("office__hitcount");

                hitLabel.innerText = hits;
            },
            searchOffices: () => {
                const searchButton = document.getElementById("search-offices");
                const resetButton = document.getElementById("list-all-offices");
                const searchField = document.getElementById("search-offices-input");
                const mapContainer = document.getElementById("map-container");
                const mapOffices = mapContainer.querySelectorAll(".map__results li:not(.no-hits)");
                const noHits = document.getElementById("no-hits");

                

                if (searchButton) {
                    performSearch();

                    searchButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        performSearch();
                    });

                    resetButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        searchField.value = "";

                        performSearch();
                    });

                    function performSearch() {
                        const officeHits = [];
                        const mapLoader = document.getElementById("map__loader");
                        let searchQuery = searchField.value.toUpperCase();

                        searchQuery = searchQuery.replace(/\s+/g, '');

                        mapLoader.classList.add("map__loader--loading");

                        mapOffices.forEach((mapOffice) => {
                            const officeSearchTerms = [
                                mapOffice.getAttribute("data-office").toUpperCase().replace(/\s+/g, ''),
                                mapOffice.getAttribute("data-adress").toUpperCase().replace(/\s+/g, ''),
                                mapOffice.getAttribute("data-zip").toUpperCase().replace(/\s+/g, ''),
                                mapOffice.getAttribute("data-state").toUpperCase().replace(/\s+/g, ''),
                                mapOffice.getAttribute("data-city").toUpperCase().replace(/\s+/g, '')
                            ]

                            const officeLatitude = Number(officeListingPage.parseCoordinates(mapOffice.getAttribute("data-latitude")));
                            const officeLongitude = Number(officeListingPage.parseCoordinates(mapOffice.getAttribute("data-longitude")));

                            if (searchQuery !== "") {
                                if (officeSearchTerms.find(element => element.includes(searchQuery))) {
                                    mapOffice.style.display = "flex";

                                    officeHits.push({
                                        latitude: officeLatitude,
                                        longitude: officeLongitude,
                                        officeTitle: mapOffice.getAttribute("data-office"),
                                        officeAdress: mapOffice.getAttribute("data-adress"),
                                        officePhone: mapOffice.getAttribute("data-phone"),
                                        officeCity: mapOffice.getAttribute("data-city"),
                                        officeAdress: mapOffice.getAttribute("data-adress"),
                                        officeZip: mapOffice.getAttribute("data-zip"),
                                        officeUrl: mapOffice.getAttribute("data-url"),
                                        officePhoneLabel: mapOffice.getAttribute("data-phone-label"),
                                        officeUrlLabel: mapOffice.getAttribute("data-url-label")
                                    });
                                }
                                else {
                                    mapOffice.style.display = "none";
                                }
                            }
                            else {
                                officeHits.push({
                                    latitude: officeLatitude,
                                    longitude: officeLongitude,
                                    officeTitle: mapOffice.getAttribute("data-office"),
                                    officeAdress: mapOffice.getAttribute("data-adress"),
                                    officePhone: mapOffice.getAttribute("data-phone"),
                                    officeCity: mapOffice.getAttribute("data-city"),
                                    officeAdress: mapOffice.getAttribute("data-adress"),
                                    officeZip: mapOffice.getAttribute("data-zip"),
                                    officeUrl: mapOffice.getAttribute("data-url"),
                                    officePhoneLabel: mapOffice.getAttribute("data-phone-label"),
                                    officeUrlLabel: mapOffice.getAttribute("data-url-label")
                                });

                                mapOffice.style.display = "flex";
                            }
                        })

                        if (officeHits.length > 0) {
                            noHits.classList.remove("active");
                            officeListingPage.renderMap();
                            officeListingPage.setMapPins(officeHits);
                            officeListingPage.updateSearchHits(officeHits.length);
                        }
                        else {
                            noHits.classList.add("active");
                            officeListingPage.updateSearchHits(0);
                            officeListingPage.renderMap();
                        }
                    }
                }
            },
            toggleAllOfficesList: () => {
                const officesList = document.getElementById("all-offices-list");
                const toggleButton = document.getElementById("toggle-offices");
                const toggleLabel = toggleButton.querySelector("span");

                toggleButton.addEventListener("click", (e) => {
                    const showMoreLabel = e.target.dataset.labelAll;
                    const showLessLabel = e.target.dataset.labelLess;

                    officesList.classList.toggle("active");

                    if (officesList.classList.contains("active")) {
                        toggleLabel.innerText = showLessLabel;
                    }
                    else {
                        toggleLabel.innerText = showMoreLabel;
                    }
                })
            }
        };
        officeListingPage.init();
    }
})();
